import { classed } from "@frend-digital/ui";
import styles from "./Flex.module.css";

export const Flex = classed.div(styles.root, {
	variants: {
		align: {
			center: styles.alignCenter,
		},
		justify: {
			between: styles.justifyBetween,
			around: styles.justifyAround,
			center: styles.justifyCenter,
			start: styles.justifyStart,
			end: styles.justifyEnd,
		},
		direction: {
			row: styles.row,
			column: styles.column,
		},
	},
});
